import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppCommonModule } from './app/shared/app-common.module';
import { RootRoutingModule } from './root-routing.module';
import { RootComponent } from './root.component';
import { LoaderComponent } from './assets/loader/loader.component';
import { LoaderService } from 'src/app-core/services/loader.service';
import { HttpClientModule } from '@angular/common/http';
import { AuthService } from './app-core/auth/auth.service';
@NgModule({
  declarations: [RootComponent, LoaderComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RootRoutingModule,
    HttpClientModule,
    AppCommonModule.forRoot(),
  ],
  providers: [LoaderService,
             AuthService],
  bootstrap: [RootComponent],
})
export class RootModule {}
